import e$1, { createContext, useState, useMemo, useContext, useCallback, useRef, useDebugValue, createElement, useEffect } from 'react';
import { __awaiter, __generator, __spreadArray, __assign } from 'tslib';
import { FlexBox, Typography } from '@vp/swan';

var a$1="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function l$2(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}var c$2,u$2,s$2,f$2={exports:{}};u$2=a$1,s$2=function(){var e=function(){},n="undefined",t=typeof window!==n&&typeof window.navigator!==n&&/Trident\/|MSIE /.test(window.navigator.userAgent),o=["trace","debug","info","warn","error"],r={},i=null;function a(e,n){var t=e[n];if("function"==typeof t.bind)return t.bind(e);try{return Function.prototype.bind.call(t,e)}catch(n){return function(){return Function.prototype.apply.apply(t,[e,arguments])}}}function l(){console.log&&(console.log.apply?console.log.apply(console,arguments):Function.prototype.apply.apply(console.log,[console,arguments])),console.trace&&console.trace();}function c(){for(var t=this.getLevel(),r=0;r<o.length;r++){var i=o[r];this[i]=r<t?e:this.methodFactory(i,t,this.name);}if(this.log=this.debug,typeof console===n&&t<this.levels.SILENT)return "No console available for logging"}function u(e){return function(){typeof console!==n&&(c.call(this),this[e].apply(this,arguments));}}function s(o,r,i){return function(o){return "debug"===o&&(o="log"),typeof console!==n&&("trace"===o&&t?l:void 0!==console[o]?a(console,o):void 0!==console.log?a(console,"log"):e)}(o)||u.apply(this,arguments)}function f(e,t){var a,l,u,f=this,p="loglevel";function g(){var e;if(typeof window!==n&&p){try{e=window.localStorage[p];}catch(e){}if(typeof e===n)try{var t=window.document.cookie,o=encodeURIComponent(p),r=t.indexOf(o+"=");-1!==r&&(e=/^([^;]+)/.exec(t.slice(r+o.length+1))[1]);}catch(e){}return void 0===f.levels[e]&&(e=void 0),e}}function d(e){var n=e;if("string"==typeof n&&void 0!==f.levels[n.toUpperCase()]&&(n=f.levels[n.toUpperCase()]),"number"==typeof n&&n>=0&&n<=f.levels.SILENT)return n;throw new TypeError("log.setLevel() called with invalid level: "+e)}"string"==typeof e?p+=":"+e:"symbol"==typeof e&&(p=void 0),f.name=e,f.levels={TRACE:0,DEBUG:1,INFO:2,WARN:3,ERROR:4,SILENT:5},f.methodFactory=t||s,f.getLevel=function(){return null!=u?u:null!=l?l:a},f.setLevel=function(e,t){return u=d(e),!1!==t&&function(e){var t=(o[e]||"silent").toUpperCase();if(typeof window!==n&&p){try{return void(window.localStorage[p]=t)}catch(e){}try{window.document.cookie=encodeURIComponent(p)+"="+t+";";}catch(e){}}}(u),c.call(f)},f.setDefaultLevel=function(e){l=d(e),g()||f.setLevel(e,!1);},f.resetLevel=function(){u=null,function(){if(typeof window!==n&&p){try{window.localStorage.removeItem(p);}catch(e){}try{window.document.cookie=encodeURIComponent(p)+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC";}catch(e){}}}(),c.call(f);},f.enableAll=function(e){f.setLevel(f.levels.TRACE,e);},f.disableAll=function(e){f.setLevel(f.levels.SILENT,e);},f.rebuild=function(){if(i!==f&&(a=d(i.getLevel())),c.call(f),i===f)for(var e in r)r[e].rebuild();},a=d(i?i.getLevel():"WARN");var v=g();null!=v&&(u=d(v)),c.call(f);}(i=new f).getLogger=function(e){if("symbol"!=typeof e&&"string"!=typeof e||""===e)throw new TypeError("You must supply a name when creating a logger.");var n=r[e];return n||(n=r[e]=new f(e,i.methodFactory)),n};var p=typeof window!==n?window.log:void 0;return i.noConflict=function(){return typeof window!==n&&window.log===i&&(window.log=p),i},i.getLoggers=function(){return r},i.default=i,i},(c$2=f$2).exports?c$2.exports=s$2():u$2.log=s$2();var p$1=l$2(f$2.exports),g$2="SILENT",d$1=null,v$2=function(e){var n=(void 0===e?{}:e).level,t=void 0===n?"":n;if(d$1)return d$1.warn("Logger Already Initialized!"),d$1;var o=function(e){if(null==e||""===e)return !1;var n=!1;if("number"==typeof e)e>=0&&e<=5&&(n=!0);else if("string"==typeof e){var t=e.toUpperCase();Object.keys(p$1.levels).forEach((function(e){t===e&&(n=!0);}));}return n}(t);o||console.error("Invalid logging level provided, returning a silent logger. There will be no console output.");var r=o?t:p$1.levels.SILENT,i=p$1.getLogger("om-translations-logger");return i.setLevel(r,!1),(d$1=i).trace("Initialized Logger with level:",t),d$1},y$2=function(){return d$1||v$2({level:g$2}),d$1},w$2=createContext({activeTranslationDictionary:{},defaultTranslationDictionary:{},targetLocale:"",setLocale:function(){}}),h$1=function(n){var r=n.children,i=n.translationResources,a=n.locale,l=void 0===a?"":a,c=n.logLevel,u=void 0===c?g$2:c,s=e$1.useMemo((function(){return v$2({level:u})}),[u]),f=useState(l),p=f[0],d=f[1];e$1.useEffect((function(){l&&d(l.toLowerCase());}),[l]);var y=i,h=useMemo((function(){return {activeTranslationDictionary:y[p.toLowerCase()]||{},defaultTranslationDictionary:y["en-us"]||{},targetLocale:p,setLocale:d}}),[y,p]);return s.trace("[LocalizationProvider] Rendering with locale: ".concat(p),i,h.activeTranslationDictionary,h.defaultTranslationDictionary),e$1.createElement(w$2.Provider,{value:h},r)},T$1=function(){var e=useContext(w$2).activeTranslationDictionary;return {localizationLookUpFunction:useCallback((function(n,t){if(!!!e[n])return {hasAllCopy:!1,copiesMissing:["Translation group not found"]};var o=t.filter((function(t){return !Object.keys(e[n]).includes(t)}));return {hasAllCopy:0===o.length,copiesMissing:o}}),[e])}},L$1=function(e){var n=e.translationGroup,t=e.targetLocale,o=e.activeTranslationGroup,r=void 0===o?{}:o,i=e.defaultTranslationGroup,a=void 0===i?{}:i,l=e.logger;return new Proxy(r,{get:function(e,o){if(Object.prototype.hasOwnProperty.call(r,o)){var i=r[o];return "string"==typeof i?i:"object"==typeof i&&i.value&&"string"==typeof i.value?i.value:(l.error("".concat(o," is invalid in translation group: ").concat(n)),"[".concat(n,".").concat(o,"]"))}return a[o]?l.warn("".concat(o," does not exist in translation group: ").concat(n," in targetLocale: ").concat(t,", however does exist in DEFAULT language.")):l.error("".concat(o," does not exist in translation group: ").concat(n," in targetLocale: ").concat(t,", or in DEFAULT language.")),"[".concat(n,".").concat(o,"]")}})},m$2=function(e){var n=useContext(w$2),t=n.activeTranslationDictionary,o=n.defaultTranslationDictionary,i=n.targetLocale,a=y$2(),l=T$1().localizationLookUpFunction;return e.map((function(e){return t[e]?L$1({translationGroup:e,activeTranslationGroup:t[e],defaultTranslationGroup:o[e],targetLocale:i,logger:a}):function(e){var n=e.missingTranslationGroup,t=e.defaultTranslationDictionary,o=e.targetLocale,r=e.logger;return t[n]?r.warn("No Translation Group: ".concat(n," in ").concat(o,", this group DOES exist in default language!")):r.error("No Translation Group: ".concat(n," in ").concat(o," or DEFAULT language.")),L$1({translationGroup:n,targetLocale:o,defaultTranslationGroup:t[n],logger:r})}({missingTranslationGroup:e,defaultTranslationDictionary:o,targetLocale:i,logger:a})})).concat([l])},b$1=function(n){var t=n.tokenizedString,o=n.substitutions,r=y$2(),i=function(e){for(var n,t,o=/(\{\{\{start([^}]+)\}\}\}(.+)\{\{\{end\2\}\}\})|\{\{\{([^}]+)\}\}\}|([^{]+)/y,r=[];t=e,n=o.exec(t);){var i=n||[];i[0];var a=i[1],l=i[2],c=i[3],u=i[4],s=i[5];a?r.push({nestedTokenName:l,nestedText:c}):u?r.push({token:u}):s&&r.push({text:s});}return r}(t);return r.info("[ReplaceTokens] tokeniedString: ".concat(t," Tokens: ").concat(i.toString())),e$1.createElement(e$1.Fragment,null,i.map((function(n,t){var i=n.token,a=n.text,l=n.nestedText,c=n.nestedTokenName;if(a)return e$1.createElement("span",{key:t},a);if(i)return o[i]?e$1.createElement("span",{key:t},o[i]):(r.error("No substitution provided for token ".concat(i,", returning empty element.")),null);if(c){var u=e$1.createElement(b$1,{substitutions:o,tokenizedString:l});return o[c]?"function"!=typeof o[c]?(r.error("Substitue provided for nested token ".concat(c,", was not a function, returning children without wrapping.")),u):o[c]({children:u}):(r.error("No substitute component provided for nested token ".concat(c,", returning children without wrapping.")),u)}return null})))};

function e(e,t,r,s){return new(r||(r=Promise))((function(n,o){function i(e){try{c(s.next(e));}catch(e){o(e);}}function u(e){try{c(s.throw(e));}catch(e){o(e);}}function c(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t);}))).then(i,u);}c((s=s.apply(e,t||[])).next());}))}"function"==typeof SuppressedError&&SuppressedError;class t extends Error{constructor(e){super(e),this.rootStack="",this.response=void 0,this.request=void 0,this.config={},this.isRetryable=!1,Object.setPrototypeOf(this,t.prototype);}}const r=/[/?#]/,s$1=/timeout/,n="UNKNOWN",o=e=>{if(!e||"string"!=typeof e)return "";const t=e.replace("http://","").replace("https://","").split(r);return t&&t.length>0?t[0]:n};let i$1 = class i{constructor(){this.handlers=[];}use(e,t){this.handlers.push([e,t]);}get(){return this.handlers}};function u$1(t){const{url:r,timeout:s=null,maxAttempts:n=1}=t,o=function(e,t){var r={};for(var s in e)Object.prototype.hasOwnProperty.call(e,s)&&t.indexOf(s)<0&&(r[s]=e[s]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(s=Object.getOwnPropertySymbols(e);n<s.length;n++)t.indexOf(s[n])<0&&Object.prototype.propertyIsEnumerable.call(e,s[n])&&(r[s[n]]=e[s[n]]);}return r}(t,["url","timeout","maxAttempts"]),i=u$1.requestInterceptors.get().reverse(),c=u$1.responseInterceptors.get();let l=Promise.resolve(o);const p=[...i,[t=>e(this,void 0,void 0,(function*(){let e,o,i=0;do{let n;try{let i;if(s){const e=new AbortController;i=e.signal,n=setTimeout((()=>e.abort("fetch timeout hit, aborting")),s);}const{params:u}=t,c=new URLSearchParams(Object.assign({},u)),l=[...c].length>0;o=new Request([r,l&&c].filter(Boolean).join("?"),Object.assign(Object.assign({},t),{signal:i}));e={response:yield fetch(o),request:o};}catch(t){e={error:{message:t,request:o}};}finally{n&&clearTimeout(n);}i+=1;}while(i<n&&(!("response"in e)||!e.response.ok));return "response"in e?{request:e.request,response:e.response}:Promise.reject(e.error)})),void 0],...c];for(;p.length;){const[e,t]=p.shift();l=l.then(e,t);}return l}u$1.requestInterceptors=new i$1,u$1.responseInterceptors=new i$1;const c$1=(e,r,i)=>{if(r){const s=(null==r?void 0:r.status)||n,i=(null==e?void 0:e.method)||n,u=(null==r?void 0:r.url)||(null==e?void 0:e.url)||"",c=o(u),l=new t(`[FETCH][STATUSCODE=${s}][METHOD=${i}][DOMAIN=${c}]`);return l.response=r,l.request=e,l.isRetryable="number"==typeof s&&(s>499&&s<600),l}if(e){const r=e.url||"",u=o(r),c=e.method||n;let l;return s$1.test(i.message)?(l=new t(`[FETCH][TIMEOUT][METHOD=${c}][DOMAIN=${u}]`),l.isRetryable=!0):l=new t(`[FETCH][REQUEST FAILED][METHOD=${c}][DOMAIN=${u}]`),l.rootStack=null==i?void 0:i.stack,l.request=null==i?void 0:i.request,l}return i};u$1.requestInterceptors.use((e=>e)),u$1.responseInterceptors.use((e=>{const{request:t,response:r}=e;return r.ok?r:Promise.reject(c$1(t,r))}),(e=>{const{request:t}=e;return Promise.reject(c$1(t,void 0,e))}));const l$1=e=>({Authorization:e});

var VISTACART_URL_ENV = 'https://vistacart.orders.vpsvc.com';
function getShippingQuote(shopperId, authorizationHeader, tenant, shippingMethodsToPrice, vistacartUrl, clientRequestor) {
  var url = vistacartUrl || VISTACART_URL_ENV;
  var requestor = encodeURIComponent(clientRequestor ? "freeShippingOverThreshold-".concat(clientRequestor) : "freeShippingOverThreshold");
  return u$1({
    url: "".concat(url, "/tenants/").concat(tenant, "/shipping/").concat(shopperId, "/shippingpricing/estimated?shippingMethodIds=").concat(shippingMethodsToPrice, "&requestor=").concat(requestor),
    method: 'get',
    headers: l$1(authorizationHeader)
  }).then(function (body) {
    return body.json();
  });
}
function priceShippingMethods(shopperId, authorizationHeader, tenant, shippingMethodsToPrice, vistacartUrl, clientRequestor) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!shippingMethodsToPrice || shippingMethodsToPrice.length === 0) return [2 /*return*/, {}];
          _a.label = 1;
        case 1:
          _a.trys.push([1, 3,, 4]);
          return [4 /*yield*/, getShippingQuote(shopperId, authorizationHeader, tenant, shippingMethodsToPrice, vistacartUrl, clientRequestor)];
        case 2:
          return [2 /*return*/, _a.sent() || {}];
        case 3:
          _a.sent();
          return [2 /*return*/, {}];
        case 4:
          return [2 /*return*/];
      }
    });
  });
}

/**
 * Returns a boolean indicating if the first free shipping details should be given
 * higher display priority over the second free shipping details.
 * @param prev
 * @param cur
 */
var sharedReducer = function (prev, cur) {
  var _a, _b;
  var previousAmountToFreeCents = ((_a = prev.freeShippingDetails) === null || _a === void 0 ? void 0 : _a.amountToFreeCents) === undefined ? Number.MAX_SAFE_INTEGER : prev.freeShippingDetails.amountToFreeCents;
  var currentAmountToFreeCents = ((_b = cur.freeShippingDetails) === null || _b === void 0 ? void 0 : _b.amountToFreeCents) === undefined ? Number.MAX_SAFE_INTEGER : cur.freeShippingDetails.amountToFreeCents;
  // choose the method with a smaller amount to free cents
  if (previousAmountToFreeCents < currentAmountToFreeCents) {
    return true;
  }
  // if both methods have the same amount to free cents value, choose the method with a higher list price
  if (previousAmountToFreeCents === currentAmountToFreeCents) {
    return (prev.netListCents || 0) > (cur.netListCents || 0);
  }
  return false;
};
/**
 * Returns the delivery option with the "nearest" free shipping threshold. If there are
 * no options with a free shipping threshold, returns undefined.
 *
 * @param deliveryOptions - list of delivery options gathered from SPEEDO's tenant
 * defaults endpoint and priced using VistaCart.
 */
var getNearestFreeShipping = function (deliveryOptions) {
  // find all options that have a free shipping hurdle
  var freeShippingOptions = deliveryOptions.filter(function (option) {
    var _a;
    return ((_a = option.freeShippingDetails) === null || _a === void 0 ? void 0 : _a.amountToFreeCents) !== undefined ? option : null;
  });
  // if no options have a free shipping hurdle, return an empty object
  if (freeShippingOptions.length === 0) {
    return;
  }
  return freeShippingOptions.reduce(function (prev, cur) {
    var prevHasPriority = sharedReducer({
      freeShippingDetails: prev.freeShippingDetails,
      netListCents: prev.shippingNetListPriceCents
    }, {
      freeShippingDetails: cur.freeShippingDetails,
      netListCents: cur.shippingNetListPriceCents
    });
    return prevHasPriority ? prev : cur;
  });
};
/**
 * Returns the delivery option with the "nearest" free shipping threshold. If there are
 * no options with a free shipping threshold, returns undefined.
 *
 * @param shippingQuotes - list of shipping quotes provided by the client using this
 * package.
 */
var getNearestFreeShippingForClientOptions = function (shippingQuotes) {
  // find all options that have a free shipping hurdle
  var freeShippingQuotes = shippingQuotes.filter(function (sq) {
    var _a, _b;
    return ((_b = (_a = sq.pricingData) === null || _a === void 0 ? void 0 : _a.freeShippingDetails) === null || _b === void 0 ? void 0 : _b.amountToFreeCents) !== undefined;
  });
  if (freeShippingQuotes.length === 0) {
    return;
  }
  return freeShippingQuotes.reduce(function (prev, cur) {
    var _a, _b, _c, _d;
    var prevHasPriority = sharedReducer({
      freeShippingDetails: (_a = prev.pricingData) === null || _a === void 0 ? void 0 : _a.freeShippingDetails,
      netListCents: (_b = prev.pricingData) === null || _b === void 0 ? void 0 : _b.netListCents
    }, {
      freeShippingDetails: (_c = cur.pricingData) === null || _c === void 0 ? void 0 : _c.freeShippingDetails,
      netListCents: (_d = cur.pricingData) === null || _d === void 0 ? void 0 : _d.netListCents
    });
    return prevHasPriority ? prev : cur;
  });
};

var SPEEDO_URL_ENV = 'https://speedo.orders.vpsvc.com';
function getDeliveryOptions(authorizationHeader, tenant, deliveryCountry, speedoUrl) {
  return __awaiter(this, void 0, void 0, function () {
    var url, error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          url = speedoUrl || SPEEDO_URL_ENV;
          return [4 /*yield*/, u$1({
            url: "".concat(url, "/shipping/shipping-options/tenants/").concat(tenant, "?deliveryCountry=").concat(deliveryCountry),
            method: 'get',
            headers: l$1(authorizationHeader)
          }).then(function (res) {
            return res.json();
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
        case 2:
          error_1 = _a.sent();
          console.warn('[FREE SHIPPING MERCHANDISE SCRIPT MOD] Failed to get shipping config data.', error_1);
          return [2 /*return*/, []];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

/**
 * Return the list of delivery option ids to price sourced from speedo.
 * @param {*} deliveryOptions
 */
var getShippingOptionsToPriceFromSpeedo = function (deliveryOptions) {
  var shippingOptionsToPrice = [];
  deliveryOptions.forEach(function (option) {
    shippingOptionsToPrice.push(option.id);
  });
  return shippingOptionsToPrice;
};
/**
 * Return the localized shipping option name for a given shipping method retrieved from SPEEDO.
 * If no name available for the given id/locale return '';
 */
var getLocalizedSpeedoShippingName = function (shippingMethodId, idToDisplayNames, locale) {
  if (!idToDisplayNames || !idToDisplayNames[shippingMethodId]) {
    return '';
  }
  var displayNames = idToDisplayNames[shippingMethodId];
  var filteredDisplayNames = displayNames.filter(function (name) {
    return name.locale === locale;
  });
  return filteredDisplayNames && filteredDisplayNames[0] && filteredDisplayNames[0].name || '';
};

var messages$f = {
	freeShippingProgressMessage: "Your order is {{{amountToFree}}} (incl. VAT) away from free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, incl. VAT)",
	freeShippingProgressMessageWithTaxTypes: "Your order is {{{amountToFree}}} (incl. {{{taxTypes}}}) away from free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, incl. {{{taxTypes}}})",
	freeShippingProgressMessageExTax: "Your order is {{{amountToFree}}} (ex. {{{taxTypes}}}) away from free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Your order is {{{amountToFree}}} (ex. VAT) away from free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. VAT)",
	freeShippingThresholdReachedMessage: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, incl. VAT)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, incl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTax: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. VAT)",
	freeShippingNoThresholdMessage: "Your order qualifies for free {{{shippingOptionName}}} delivery",
	freeShippingProgressBarLabel: "Free delivery",
	freeShippingProgressBarDescription: "Spend {{{amountToFree}}}",
	shippingDetails: "View details about delivery pricing."
};
var enGB = {
	messages: messages$f
};

var messages$e = {
	freeShippingProgressMessage: "Your order is {{{amountToFree}}} (incl. tax) away from free {{{shippingOptionName}}} delivery({{{orderThreshold}}} minimum, incl. tax)",
	freeShippingProgressMessageWithTaxTypes: "Your order is {{{amountToFree}}} (incl. {{{taxTypes}}}) away from free {{{shippingOptionName}}} delivery({{{orderThreshold}}} minimum, incl. {{{taxTypes}}})",
	freeShippingProgressMessageExTax: "Your order is {{{amountToFree}}} (ex. {{{taxTypes}}}) away from free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Your order is {{{amountToFree}}} (ex. tax) away from free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. tax)",
	freeShippingThresholdReachedMessage: "Your order qualifies for free {{{shippingOptionName}}} shipping ({{{orderThreshold}}} minimum, incl. tax)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Your order qualifies for free {{{shippingOptionName}}} shipping ({{{orderThreshold}}} minimum, incl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTax: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. )",
	freeShippingNoThresholdMessage: "Your order qualifies for free {{{shippingOptionName}}} shipping",
	freeShippingProgressBarLabel: "Free shipping",
	freeShippingProgressBarDescription: "Spend {{{amountToFree}}}",
	shippingDetails: "View details about delivery options."
};
var enIN = {
	messages: messages$e
};

var messages$d = {
	freeShippingProgressMessage: "A sua encomenda está a {{{amountToFree}}} (incl. imposto) da entrega {{{shippingOptionName}}} gratuita ({{{orderThreshold}}} no mínimo, incl. imposto)",
	freeShippingProgressMessageWithTaxTypes: "A sua encomenda está a {{{amountToFree}}} (incl. {{{taxTypes}}}) da entrega {{{shippingOptionName}}} gratuita ({{{orderThreshold}}} no mínimo, incl. {{{taxTypes}}})",
	freeShippingProgressMessageExTax: "A sua encomenda está a {{{amountToFree}}} (excl. {{{taxTypes}}}) da entrega {{{shippingOptionName}}} gratuita ({{{orderThreshold}}} no mínimo, excl. {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "A sua encomenda está a {{{amountToFree}}} (excl. imposto) da entrega {{{shippingOptionName}}} gratuita ({{{orderThreshold}}} no mínimo, excl. imposto)",
	freeShippingThresholdReachedMessage: "A sua encomenda qualifica-se para a entrega {{{shippingOptionName}}} gratuita ({{{orderThreshold}}} no mínimo, incl. imposto)",
	freeShippingThresholdReachedMessageWithTaxTypes: "A sua encomenda qualifica-se para a entrega {{{shippingOptionName}}} gratuita ({{{orderThreshold}}} no mínimo, incl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTax: "A sua encomenda qualifica-se para a entrega {{{shippingOptionName}}} gratuita ({{{orderThreshold}}} no mínimo, excl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "A sua encomenda qualifica-se para a entrega {{{shippingOptionName}}} gratuita ({{{orderThreshold}}} no mínimo, excl. imposto)",
	freeShippingNoThresholdMessage: "A sua encomenda qualifica-se para a entrega {{{shippingOptionName}}} gratuita",
	freeShippingProgressBarLabel: "Envio grátis",
	freeShippingProgressBarDescription: "Gaste {{{amountToFree}}}",
	shippingDetails: "Veja os detalhes dos preços de entrega."
};
var ptPT = {
	messages: messages$d
};

var messages$c = {
	freeShippingProgressMessage: "Te faltan {{{amountToFree}}} (impuestos incluidos) en el pedido para conseguir el envío {{{shippingOptionName}}} gratuito (el mínimo es de {{{orderThreshold}}}, impuestos incluidos)",
	freeShippingProgressMessageWithTaxTypes: "Te faltan {{{amountToFree}}} ({{{taxTypes}}} incluidos) en el pedido para conseguir el envío {{{shippingOptionName}}} gratuito (el mínimo es de {{{orderThreshold}}}, {{{taxTypes}}} incluidos)",
	freeShippingProgressMessageExTax: "Te faltan {{{amountToFree}}} ({{{taxTypes}}} excluidos) en el pedido para conseguir la entrega {{{shippingOptionName}}} gratuita (el mínimo es de {{{orderThreshold}}}, {{{taxTypes}}} excluidos)",
	freeShippingProgressMessageExTaxGeneric: "Te faltan {{{amountToFree}}} (impuestos excluidos) en el pedido para conseguir la entrega {{{shippingOptionName}}} gratuita (el mínimo es de {{{orderThreshold}}}, impuestos excluidos)",
	freeShippingThresholdReachedMessage: "Tu pedido cumple los requisitos para el envío {{{shippingOptionName}}} gratuito (el mínimo es de {{{orderThreshold}}}, impuestos incluidos)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Tu pedido cumple los requisitos para el envío {{{shippingOptionName}}} gratuito (el mínimo es de {{{orderThreshold}}}, {{{taxTypes}}} incluidos)",
	freeShippingThresholdReachedMessageExTax: "Tu pedido es apto para envío {{{shippingOptionName}}} gratis (el mínimo es de {{{orderThreshold}}}, {{{taxTypes}}} no incl.)",
	freeShippingThresholdReachedMessageExTaxGeneric: "Tu pedido es apto para envío {{{shippingOptionName}}} gratis (el mínimo es de {{{orderThreshold}}}, impuestos no incl.)",
	freeShippingNoThresholdMessage: "Tu pedido es apto para envío {{{shippingOptionName}}} gratis",
	freeShippingProgressBarLabel: "Envío gratis",
	freeShippingProgressBarDescription: "Gasta {{{amountToFree}}}",
	shippingDetails: "Ver detalles sobre los precios de envío."
};
var esES = {
	messages: messages$c
};

var messages$b = {
	freeShippingProgressMessage: "Your order is {{{amountToFree}}} (incl. tax) away from free {{{shippingOptionName}}} shipping ({{{orderThreshold}}} minimum, incl. tax)",
	freeShippingProgressMessageWithTaxTypes: "Your order is {{{amountToFree}}} (incl. {{{taxTypes}}}) away from free {{{shippingOptionName}}} shipping ({{{orderThreshold}}} minimum, incl. {{{taxTypes}}})",
	freeShippingProgressMessageExTax: "Your order is {{{amountToFree}}} (ex. {{{taxTypes}}}) away from free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Your order is {{{amountToFree}}} (ex. tax) away from free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. tax)",
	freeShippingThresholdReachedMessage: "Your order qualifies for free {{{shippingOptionName}}} shipping ({{{orderThreshold}}} minimum, incl. tax)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Your order qualifies for free {{{shippingOptionName}}} shipping ({{{orderThreshold}}} minimum, incl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTax: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. tax)",
	freeShippingNoThresholdMessage: "Your order qualifies for free {{{shippingOptionName}}} shipping",
	freeShippingProgressBarLabel: "Free shipping",
	freeShippingProgressBarDescription: "Spend {{{amountToFree}}}",
	shippingDetails: "View details about delivery pricing."
};
var enUS = {
	messages: messages$b
};

var messages$a = {
	freeShippingProgressMessage: "Mancano {{{amountToFree}}} (imposte incl.) per ottenere la spedizione {{{shippingOptionName}}} gratis per il tuo ordine (minimo {{{orderThreshold}}}, imposte incl.)",
	freeShippingProgressMessageWithTaxTypes: "Mancano {{{amountToFree}}} ({{{taxTypes}}} incl.) per ottenere la spedizione {{{shippingOptionName}}} gratis per il tuo ordine (minimo {{{orderThreshold}}}, {{{taxTypes}}}incl.)",
	freeShippingProgressMessageExTax: "Mancano {{{amountToFree}}} ({{{taxTypes}}} escl.) per ottenere la consegna {{{shippingOptionName}}} gratis per il tuo ordine (minimo {{{orderThreshold}}}, {{{taxTypes}}}escl.)",
	freeShippingProgressMessageExTaxGeneric: "Mancano {{{amountToFree}}} (imposte escl.) per ottenere la consegna {{{shippingOptionName}}} gratis per il tuo ordine (minimo {{{orderThreshold}}}, imposte escl.)",
	freeShippingThresholdReachedMessage: "Il tuo ordine ti dà diritto alla spedizione {{{shippingOptionName}}} gratis (minimo {{{orderThreshold}}}, imposte incl.)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Il tuo ordine ti dà diritto alla spedizione {{{shippingOptionName}}} gratis (minimo {{{orderThreshold}}}, {{{taxTypes}}} incl.)",
	freeShippingThresholdReachedMessageExTax: "Il tuo ordine ti dà diritto alla spedizione {{{shippingOptionName}}} gratis (minimo {{{orderThreshold}}}, {{{taxTypes}}} escl.)",
	freeShippingThresholdReachedMessageExTaxGeneric: "Il tuo ordine ti dà diritto alla spedizione {{{shippingOptionName}}} gratis (minimo {{{orderThreshold}}}, imposte escl.)",
	freeShippingNoThresholdMessage: "Il tuo ordine ti dà diritto alla spedizione {{{shippingOptionName}}} gratis",
	freeShippingProgressBarLabel: "Spedizione gratuita",
	freeShippingProgressBarDescription: "Spendi {{{amountToFree}}}",
	shippingDetails: "Visualizza i dettagli sui prezzi di consegna."
};
var itIT = {
	messages: messages$a
};

var messages$9 = {
	freeShippingProgressMessage: "Plus que {{{amountToFree}}} (TTC) sur votre commande pour bénéficier de la livraison {{{shippingOptionName}}} offerte (dès {{{orderThreshold}}} TTC)",
	freeShippingProgressMessageWithTaxTypes: "Plus que {{{amountToFree}}} ({{{taxTypes}}} comprise) sur votre commande pour bénéficier de la livraison {{{shippingOptionName}}} offerte (dès {{{orderThreshold}}} {{{taxTypes}}} comprise)",
	freeShippingProgressMessageExTax: "Plus que {{{amountToFree}}} (hors {{{taxTypes}}}) sur votre commande pour bénéficier de la livraison {{{shippingOptionName}}} offerte (dès {{{orderThreshold}}} hors {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Plus que {{{amountToFree}}} (HT) sur votre commande pour bénéficier de la livraison {{{shippingOptionName}}} offerte (dès {{{orderThreshold}}} HT)",
	freeShippingThresholdReachedMessage: "Votre commande vous donne droit à la livraison {{{shippingOptionName}}} offerte (dès {{{orderThreshold}}} TTC)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Votre commande vous donne droit à la livraison {{{shippingOptionName}}} offerte (dès {{{orderThreshold}}} {{{taxTypes}}} comprise)",
	freeShippingThresholdReachedMessageExTax: "Votre commande vous donne droit à la livraison {{{shippingOptionName}}} offerte (dès {{{orderThreshold}}} hors {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Votre commande vous donne droit à la livraison {{{shippingOptionName}}} offerte (dès {{{orderThreshold}}} HT)",
	freeShippingNoThresholdMessage: "Votre commande vous donne droit à la livraison {{{shippingOptionName}}} offerte",
	freeShippingProgressBarLabel: "Livraison offerte",
	freeShippingProgressBarDescription: "Commander {{{amountToFree}}}",
	shippingDetails: "Voir plus d’informations sur les tarifs de livraison."
};
var frFR = {
	messages: messages$9
};

var messages$8 = {
	freeShippingProgressMessage: "Noch {{{amountToFree}}} (inkl. MwSt.) für kostenlose {{{shippingOptionName}}}-Lieferung (ab {{{orderThreshold}}}, inkl. MwSt.)",
	freeShippingProgressMessageWithTaxTypes: "Noch {{{amountToFree}}} (inkl. {{{taxTypes}}}) für kostenlose {{{shippingOptionName}}}-Lieferung (ab {{{orderThreshold}}}, inkl. {{{taxTypes}}})",
	freeShippingProgressMessageExTax: "Noch {{{amountToFree}}} (zzgl. {{{taxTypes}}}) für kostenlose {{{shippingOptionName}}}-Lieferung (ab {{{orderThreshold}}}, zzgl. {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Noch {{{amountToFree}}} (zzgl. MwSt.) für kostenlose {{{shippingOptionName}}}-Lieferung (ab {{{orderThreshold}}}, zzgl. MwSt.)",
	freeShippingThresholdReachedMessage: "Ihre Bestellung qualifiziert sich für kostenlose {{{shippingOptionName}}}-Lieferung (ab {{{orderThreshold}}}, inkl. MwSt.)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Ihre Bestellung qualifiziert sich für kostenlose {{{shippingOptionName}}}-Lieferung (ab {{{orderThreshold}}}, inkl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTax: "Ihre Bestellung qualifiziert sich für kostenlose {{{shippingOptionName}}}-Lieferung (ab {{{orderThreshold}}}, zzgl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Ihre Bestellung qualifiziert sich für kostenlose {{{shippingOptionName}}}-Lieferung (ab {{{orderThreshold}}}, zzgl. MwSt.)",
	freeShippingNoThresholdMessage: "Ihre Bestellung qualifiziert sich für kostenlose {{{shippingOptionName}}}-Lieferung",
	freeShippingProgressBarLabel: "Kostenloser Versand",
	freeShippingProgressBarDescription: "{{{amountToFree}}} ausgeben",
	shippingDetails: "Details zu Lieferoptionen ansehen"
};
var deDE = {
	messages: messages$8
};

var messages$7 = {
	freeShippingProgressMessage: "Din bestilling mangler {{{amountToFree}}} (inkl. moms) for at få gratis {{{shippingOptionName}}}-levering (mindst {{{orderThreshold}}} inkl. moms)",
	freeShippingProgressMessageWithTaxTypes: "Din bestilling mangler {{{amountToFree}}} (inkl. {{{taxTypes}}}) for at få gratis {{{shippingOptionName}}}-levering (mindst {{{orderThreshold}}} inkl. {{{taxTypes}}})",
	freeShippingProgressMessageExTax: "Din bestilling mangler {{{amountToFree}}} (ekskl. {{{taxTypes}}}) for at få gratis {{{shippingOptionName}}}-levering (mindst {{{orderThreshold}}}, ekskl. {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Din bestilling mangler {{{amountToFree}}} (ekskl. moms) for at få gratis {{{shippingOptionName}}}-levering (mindst {{{orderThreshold}}}, ekskl. moms)",
	freeShippingThresholdReachedMessage: "Din bestilling kvalificerer sig til gratis {{{shippingOptionName}}}-levering (mindst {{{orderThreshold}}} inkl. moms)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Din bestilling kvalificerer sig til gratis {{{shippingOptionName}}}-levering (mindst {{{orderThreshold}}} inkl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTax: "Din bestilling kvalificerer sig til gratis {{{shippingOptionName}}}-levering (mindst {{{orderThreshold}}} ekskl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Din bestilling kvalificerer sig til gratis {{{shippingOptionName}}}-levering (mindst {{{orderThreshold}}} ekskl. afgifter)",
	freeShippingNoThresholdMessage: "Din bestilling kvalificerer sig til gratis {{{shippingOptionName}}}-levering",
	freeShippingProgressBarLabel: "Gratis levering",
	freeShippingProgressBarDescription: "Forbrug {{{amountToFree}}}",
	shippingDetails: "Se detaljer om leveringspriser."
};
var daDK = {
	messages: messages$7
};

var messages$6 = {
	freeShippingProgressMessage: "Din beställning är bara {{{amountToFree}}} (inkl. moms) från fri {{{shippingOptionName}}}-leverans (minst {{{orderThreshold}}} inkl. moms)",
	freeShippingProgressMessageWithTaxTypes: "Din beställning är bara {{{amountToFree}}} (inkl. {{{taxTypes}}}) från fri {{{shippingOptionName}}}-leverans (minst {{{orderThreshold}}} inkl. {{{taxTypes}}})",
	freeShippingProgressMessageExTax: "Din beställning är bara {{{amountToFree}}} (exkl. {{{taxTypes}}}) från fri {{{shippingOptionName}}}-frakt (minst {{{orderThreshold}}} exkl. {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Din beställning är bara {{{amountToFree}}} (exkl. moms) från fri {{{shippingOptionName}}}-frakt (minst {{{orderThreshold}}} exkl. moms)",
	freeShippingThresholdReachedMessage: "Du är berättigad till fri {{{shippingOptionName}}}-leverans (minst {{{orderThreshold}}} inkl. moms) på den här beställningen",
	freeShippingThresholdReachedMessageWithTaxTypes: "Du är berättigad till fri {{{shippingOptionName}}}-leverans (minst {{{orderThreshold}}} inkl. {{{taxTypes}}}) på den här beställningen",
	freeShippingThresholdReachedMessageExTax: "Du är berättigad till fri {{{shippingOptionName}}}-frakt på denna beställning (minst {{{orderThreshold}}}, exkl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Du är berättigad till fri {{{shippingOptionName}}}-frakt på denna beställning (minst {{{orderThreshold}}}, exkl. moms)",
	freeShippingNoThresholdMessage: "Du är berättigad till fri {{{shippingOptionName}}}-leverans på den här beställningen",
	freeShippingProgressBarLabel: "Gratis leverans",
	freeShippingProgressBarDescription: "Handla för {{{amountToFree}}}",
	shippingDetails: "Visa detaljer om leveranspriser."
};
var svSE = {
	messages: messages$6
};

var messages$5 = {
	freeShippingProgressMessage: "Bestillingen din er {{{amountToFree}}} (inkl. mva) fra gratis {{{shippingOptionName}}} levering ({{{orderThreshold}}} minimum, inkl. mva.)",
	freeShippingProgressMessageWithTaxTypes: "Bestillingen din er {{{amountToFree}}} (inkl. {{{taxTypes}}}) fra gratis {{{shippingOptionName}}} levering ({{{orderThreshold}}} minimum, inkl. {{{taxTypes}}})",
	freeShippingProgressMessageExTax: "Bestillingen din er {{{amountToFree}}} (ekskl. {{{taxTypes}}}) fra gratis {{{shippingOptionName}}} levering ({{{orderThreshold}}} minimum, ekskl. {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Bestillingen din er {{{amountToFree}}} (ekskl. mva) fra gratis {{{shippingOptionName}}} levering ({{{orderThreshold}}} minimum, ekskl. mva.)",
	freeShippingThresholdReachedMessage: "Bestillingen din oppfyller vilkårene for gratis {{{shippingOptionName}}} levering ({{{orderThreshold}}} minimum, inkl. mva.)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Bestillingen din oppfyller vilkårene for gratis {{{shippingOptionName}}} levering ({{{orderThreshold}}} minimum, inkl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTax: "Bestillingen din oppfyller vilkårene for gratis {{{shippingOptionName}}} levering ({{{orderThreshold}}} minimum, ekskl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Bestillingen din oppfyller vilkårene for gratis {{{shippingOptionName}}} levering ({{{orderThreshold}}} minimum, ekskl. mva.)",
	freeShippingNoThresholdMessage: "Bestillingen din oppfyller vilkårene for gratis {{{shippingOptionName}}} levering",
	freeShippingProgressBarLabel: "Gratis frakt",
	freeShippingProgressBarDescription: "Bruk {{{amountToFree}}}",
	shippingDetails: "Se informasjon om leveringspriser."
};
var nbNO = {
	messages: messages$5
};

var messages$4 = {
	freeShippingProgressMessage: "Jos käytät tilaukseesi {{{amountToFree}}} enemmän (ml. verot), saat maksuttoman {{{shippingOptionName}}}-toimituksen (minimi {{{orderThreshold}}}, sis. verot)",
	freeShippingProgressMessageWithTaxTypes: "Jos käytät tilaukseesi {{{amountToFree}}} enemmän (ml. {{{taxTypes}}}) saat maksuttoman {{{shippingOptionName}}}-toimituksen (minimi {{{orderThreshold}}}, sis. {{{taxTypes}}} )",
	freeShippingProgressMessageExTax: "Jos käytät tilaukseesi {{{amountToFree}}} enemmän (pl. {{{taxTypes}}}), saat maksuttoman {{{shippingOptionName}}}-toimituksen (minimi {{{orderThreshold}}}, pl. {{{taxTypes}}} )",
	freeShippingProgressMessageExTaxGeneric: "Jos käytät tilaukseesi {{{amountToFree}}} enemmän (pl. verot) saat maksuttoman {{{shippingOptionName}}}-toimituksen (minimi {{{orderThreshold}}}, pl. verot)",
	freeShippingThresholdReachedMessage: "Tilauksesi on oikeutettu maksuttomaan {{{shippingOptionName}}}-toimitukseen (minimi {{{orderThreshold}}}, sis. verot)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Tilauksesi on oikeutettu maksuttomaan {{{shippingOptionName}}}-toimitukseen (minimi {{{orderThreshold}}}, sis. verot)",
	freeShippingThresholdReachedMessageExTax: "Tilauksesi on oikeutettu maksuttomaan {{{shippingOptionName}}}-toimitukseen (minimi {{{orderThreshold}}}, pl.{{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Tilauksesi on oikeutettu maksuttomaan {{{shippingOptionName}}}-toimitukseen (minimi {{{orderThreshold}}}, pl. verot)",
	freeShippingNoThresholdMessage: "Tilauksesi on oikeutettu maksuttomaan {{{shippingOptionName}}}-toimitukseen",
	freeShippingProgressBarLabel: "Ilmainen toimitus",
	freeShippingProgressBarDescription: "Käytä {{{amountToFree}}}",
	shippingDetails: "Tarkastele toimitushintoja koskevia tietoja."
};
var fiFI = {
	messages: messages$4
};

var messages$3 = {
	freeShippingProgressMessage: "Je komt {{{amountToFree}}} (incl. belasting) tekort voor gratis {{{shippingOptionName}}} verzending (vanaf {{{orderThreshold}}} incl. belasting)",
	freeShippingProgressMessageWithTaxTypes: "Je komt {{{amountToFree}}} (incl. {{{taxTypes}}}) tekort voor gratis {{{shippingOptionName}}} verzending (vanaf {{{orderThreshold}}} incl. {{{taxTypes}}})",
	freeShippingProgressMessageExTax: "Je komt {{{amountToFree}}} (excl. {{{taxTypes}}}) tekort voor gratis {{{shippingOptionName}}} verzending (vanaf {{{orderThreshold}}} excl. {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Je komt {{{amountToFree}}} (excl. belasting) tekort voor gratis {{{shippingOptionName}}} verzending (vanaf {{{orderThreshold}}} excl. belasting)",
	freeShippingThresholdReachedMessage: "Je bestelling komt in aanmerking voor gratis {{{shippingOptionName}}} verzending (vanaf {{{orderThreshold}}} incl. belasting)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Je bestelling komt in aanmerking voor gratis {{{shippingOptionName}}} verzending (vanaf {{{orderThreshold}}} incl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTax: "Je bestelling komt in aanmerking voor gratis {{{shippingOptionName}}} verzending (vanaf {{{orderThreshold}}}, excl. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Je bestelling komt in aanmerking voor gratis {{{shippingOptionName}}} verzending (vanaf {{{orderThreshold}}}, excl. belasting)",
	freeShippingNoThresholdMessage: "Je bestelling komt in aanmerking voor gratis {{{shippingOptionName}}} verzending",
	freeShippingProgressBarLabel: "Gratis verzending",
	freeShippingProgressBarDescription: "Besteed {{{amountToFree}}}",
	shippingDetails: "Bekijk meer informatie over verzendprijzen."
};
var nlNL = {
	messages: messages$3
};

var messages$2 = {
	freeShippingProgressMessage: "Votre commande n’est plus qu’à {{{amountToFree}}} (taxes incluses) de la livraison {{{shippingOptionName}}} offerte ({{{orderThreshold}}} minimum, taxes incluses)",
	freeShippingProgressMessageWithTaxTypes: "Votre commande n’est plus qu’à {{{amountToFree}}} ({{{taxTypes}}} incl.) de la livraison {{{shippingOptionName}}} offerte ({{{orderThreshold}}} minimum, {{{taxTypes}}} incl.)",
	freeShippingProgressMessageExTax: "Votre commande n’est plus qu’à {{{amountToFree}}} ({{{taxTypes}}} en sus) de la livraison {{{shippingOptionName}}} offerte ({{{orderThreshold}}} minimum, {{{taxTypes}}} en sus)",
	freeShippingProgressMessageExTaxGeneric: "Votre commande n’est plus qu’à {{{amountToFree}}} (taxes en sus) de la livraison {{{shippingOptionName}}} offerte ({{{orderThreshold}}} minimum, taxes en sus)",
	freeShippingThresholdReachedMessage: "Votre commande vous donne droit à la livraison {{{shippingOptionName}}} offerte ({{{orderThreshold}}} minimum, taxes incluses)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Votre commande vous donne droit à la livraison {{{shippingOptionName}}} offerte ({{{orderThreshold}}} minimum, {{{taxTypes}}} incl.)",
	freeShippingThresholdReachedMessageExTax: "Votre commande vous donne droit à la livraison {{{shippingOptionName}}} offerte ({{{orderThreshold}}} minimum, {{{taxTypes}}} en sus)",
	freeShippingThresholdReachedMessageExTaxGeneric: "Votre commande vous donne droit à la livraison {{{shippingOptionName}}} offerte ({{{orderThreshold}}} minimum, taxes en sus)",
	freeShippingNoThresholdMessage: "Votre commande vous donne droit à la livraison {{{shippingOptionName}}} offerte",
	freeShippingProgressBarLabel: "Livraison gratuite",
	freeShippingProgressBarDescription: "Dépensez {{{amountToFree}}}",
	shippingDetails: "Consultez les détails des tarifs de livraison."
};
var frCA = {
	messages: messages$2
};

var messages$1 = {
	freeShippingProgressMessage: "Su pedido necesita {{{amountToFree}}}(con impuestos) para obtener {{{shippingOptionName}}} envío gratis (mínimo {{{orderThreshold}}}, con impuestos.)",
	freeShippingProgressMessageWithTaxTypes: "Su pedido necesita {{{amountToFree}}} (con {{{taxTypes}}}) para obtener envío {{{shippingOptionName}}}gratis ({{{orderThreshold}}}mínimo, con{{{taxTypes}}})",
	freeShippingProgressMessageExTax: "Su pedido necesita {{{amountToFree}}} (sin {{{taxTypes}}}) para obtener entrega {{{shippingOptionName}}}gratis ({{{orderThreshold}}}mínimo, sin {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Su pedido necesita {{{amountToFree}}} (sin impuestos) para obtener entrega {{{shippingOptionName}}} gratis ({{{orderThreshold}}}mínimo, sin impuestos)",
	freeShippingThresholdReachedMessage: "Su pedido califica para {{{shippingOptionName}}} envío gratis (mínimo {{{orderThreshold}}}, con impuestos)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Su pedido califica para {{{shippingOptionName}}} envío gratis (mínimo {{{orderThreshold}}}, con {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTax: "Su pedido califica para {{{shippingOptionName}}} envío gratis (mínimo {{{orderThreshold}}}, sin incluir {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Su pedido califica para {{{shippingOptionName}}} envío gratis (mínimo {{{orderThreshold}}}, sin incluir impuestos)",
	freeShippingNoThresholdMessage: "Su pedido califica para {{{shippingOptionName}}} envío gratis",
	freeShippingProgressBarLabel: "Envío gratis",
	freeShippingProgressBarDescription: "Gaste {{{amountToFree}}}",
	shippingDetails: "Ver detalles sobre los precios para envíos."
};
var esUS = {
	messages: messages$1
};

var messages = {
	freeShippingProgressMessage: "Your order is {{{amountToFree}}} (incl. tax) away from free {{{shippingOptionName}}} shipping ({{{orderThreshold}}} minimum, incl. tax)",
	freeShippingProgressMessageWithTaxTypes: "Your order is {{{amountToFree}}} away from free {{{taxTypes}}} delivery ({{{shippingOptionName}}} minimum)",
	freeShippingProgressMessageExTax: "Your order is {{{amountToFree}}} (ex. {{{taxTypes}}}) away from free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. {{{taxTypes}}})",
	freeShippingProgressMessageExTaxGeneric: "Your order is {{{amountToFree}}} (ex. tax) away from free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. tax)",
	freeShippingThresholdReachedMessage: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum)",
	freeShippingThresholdReachedMessageWithTaxTypes: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum)",
	freeShippingThresholdReachedMessageExTax: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. {{{taxTypes}}})",
	freeShippingThresholdReachedMessageExTaxGeneric: "Your order qualifies for free {{{shippingOptionName}}} delivery ({{{orderThreshold}}} minimum, ex. tax)",
	freeShippingNoThresholdMessage: "Your order qualifies for free {{{shippingOptionName}}} delivery",
	freeShippingProgressBarLabel: "Free shipping",
	freeShippingProgressBarDescription: "Spend {{{amountToFree}}}",
	shippingDetails: "View details about delivery options."
};
var enAU = {
	messages: messages
};

var translationResources = {
  'da-dk': daDK,
  'de-at': deDE,
  'de-ch': deDE,
  'de-de': deDE,
  'en-ca': enUS,
  'en-ie': enGB,
  'en-gb': enGB,
  'en-au': enAU,
  'en-nz': enAU,
  'en-sg': enAU,
  'en-in': enIN,
  'en-us': enUS,
  'es-es': esES,
  'es-us': esUS,
  'it-ch': itIT,
  'it-it': itIT,
  'fi-fi': fiFI,
  'fr-be': frFR,
  'fr-ca': frCA,
  'fr-ch': frFR,
  'fr-fr': frFR,
  'nb-no': nbNO,
  'nl-be': nlNL,
  'nl-nl': nlNL,
  'pt-pt': ptPT,
  'sv-se': svSE
};

var componentName = '[@vp/om-currency]';
var fallbackString = '...'; // TODO: do we want to make fallback string configurable?
var validateFractionDigits = function (currency, fracionDigits) {
    if (!currency) {
        var errMsg = "".concat(componentName, " Currency is required but got ").concat(currency);
        throw errMsg;
    }
    if (typeof fracionDigits === 'number' && fracionDigits >= 0) {
        return fracionDigits;
    }
    // Fraction digits is either NaN, or negative number...
    // no bueno, but we can find a fallback since currency is not falsy here
    return currency.toUpperCase() === 'JPY' ? 0 : 2;
};
var isCentInvalid = function (cents) {
    if (typeof cents !== 'number') {
        console.error("".concat(componentName, ": Prop 'cents' should be a number, but got ").concat(cents, "."));
        return true;
    }
    return false;
};
/**
 * Formatter for currency
 * @param locale OM-supported locale, e.g. 'en-IE'
 * @param currency OM-supported currency, e.g. 'EUR'
 * @param cents amount in minor unit
 * @param fractionDigits fraction digit of the currency
 */
var currencyFormatter = function (locale, currency, cents, fractionDigits) {
    if (isCentInvalid(cents)) {
        return fallbackString;
    }
    try {
        var validatedFractionDigits = validateFractionDigits(currency, fractionDigits);
        return Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
        }).format(cents / Math.pow(10, validatedFractionDigits));
    }
    catch (error) {
        console.error(componentName, error);
        return fallbackString;
    }
};
/**
 * Wrapper for currencyFormatter
 * @param props takes locale, currency, cents and fractionDigits for currencyFormatter
 */
var Currency = function (_a) {
    var cents = _a.cents, currency = _a.currency, locale = _a.locale, fractionDigits = _a.fractionDigits;
    return e$1.createElement("span", null, currencyFormatter(locale, currency, cents, fractionDigits));
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @param {number} position
 * @return {number}
 */
function indexof (value, search, position) {
	return value.indexOf(search, position)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

/**
 * @param {string[]} array
 * @param {RegExp} pattern
 * @return {string[]}
 */
function filter (array, pattern) {
	return array.filter(function (value) { return !match(value, pattern) })
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {object[]} siblings
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length, siblings) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: '', siblings: siblings}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0, root.siblings), root, {length: -root.length}, props)
}

/**
 * @param {object} root
 */
function lift (root) {
	while (root.root)
		root = copy(root.root, {children: [root]});

	append(root, root.siblings);
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f', abs(index ? points[index - 1] : 0)) != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent, declarations), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1, declarations) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length, siblings)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @param {object[]} siblings
 * @return {object}
 */
function comment (value, root, parent, siblings) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0, siblings)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function declaration (value, root, parent, length, siblings) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length, siblings)
}

/**
 * @param {string} value
 * @param {number} length
 * @param {object[]} children
 * @return {string}
 */
function prefix (value, length, children) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// tab-size
		case 4789:
			return MOZ + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// writing-mode
		case 5936:
			switch (charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
				// default: fallthrough to below
			}
		// flex, flex-direction, scroll-snap-type, writing-mode
		case 6828: case 4268: case 2903:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/g, '') + (!match(value, /flex-|baseline/) ? MS + 'grid-row-' + replace(value, /flex-|-self/g, '') : '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/g, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// justify-self
		case 4200:
			if (!match(value, /flex-|baseline/)) return MS + 'grid-column-align' + substr(value, length) + value
			break
		// grid-template-(columns|rows)
		case 2592: case 3360:
			return MS + replace(value, 'template-', '') + value
		// grid-(row|column)-start
		case 4384: case 3616:
			if (children && children.some(function (element, index) { return length = index, match(element.props, /grid-\w+-end/) })) {
				return ~indexof(value + (children = children[length].value), 'span', 0) ? value : (MS + replace(value, '-start', '') + value + MS + 'grid-row-span:' + (~indexof(children, 'span', 0) ? match(children, /\d+/) : +match(children, /\d+/) - +match(value, /\d+/)) + ';')
			}
			return MS + replace(value, '-start', '') + value
		// grid-(row|column)-end
		case 4896: case 4128:
			return (children && children.some(function (element) { return match(element.props, /grid-\w+-start/) })) ? value : MS + replace(replace(value, '-end', '-span'), 'span ', '') + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (strlen(value) - 1 - length > 6)
				switch (charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch', 0) ? prefix(replace(value, 'stretch', 'fill-available'), length, children) + value : value
				}
			break
		// grid-(column|row)
		case 5152: case 5920:
			return replace(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function (_, a, b, c, d, e, f) { return (MS + a + ':' + b + f) + (c ? (MS + a + '-span:' + (d ? e : +e - +b)) + f : '') + value })
		// position: sticky
		case 4949:
			// stick(y)?
			if (charat(value, length + 6) === 121)
				return replace(value, ':', ':' + WEBKIT) + value
			break
		// display: (flex|inline-flex|grid|inline-grid)
		case 6444:
			switch (charat(value, charat(value, 14) === 45 ? 18 : 11)) {
				// (inline-)?fle(x)
				case 120:
					return replace(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
				// (inline-)?gri(d)
				case 100:
					return replace(value, ':', ':' + MS) + value
			}
			break
		// scroll-margin, scroll-margin-(top|right|bottom|left)
		case 5719: case 2647: case 2135: case 3927: case 2391:
			return replace(value, 'scroll-', 'scroll-snap-') + value
	}

	return value
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';

	for (var i = 0; i < children.length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: if (!strlen(element.value = element.props.join(','))) return ''
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children);
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(children = element.props, function (value) {
							switch (match(value, callback = /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									lift(copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]}));
									lift(copy(element, {props: [value]}));
									assign(element, {props: filter(children, callback)});
									break
								// :placeholder
								case '::placeholder':
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}));
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}));
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]}));
									lift(copy(element, {props: [value]}));
									assign(element, {props: filter(children, callback)});
									break
							}

							return ''
						})
			}
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var f$1="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",m$1="active",y$1="data-styled-version",v$1="6.1.8",g$1="/*!sc*/\n",S$1="undefined"!=typeof window&&"HTMLElement"in window,w$1=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!==process.env.NODE_ENV),E$1=/invalid hook call/i,N=new Set,P=function(t,n){if("production"!==process.env.NODE_ENV){var o=n?' with the id of "'.concat(n,'"'):"",s="The component ".concat(t).concat(o," has been created dynamically.\n")+"You may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",i=console.error;try{var a=!0;console.error=function(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];E$1.test(t)?(a=!1,N.delete(s)):i.apply(void 0,__spreadArray([t],n,!1));},useRef(),a&&!N.has(s)&&(console.warn(s),N.add(s));}catch(e){E$1.test(e.message)&&N.delete(s);}finally{console.error=i;}}},_=Object.freeze([]),C$1=Object.freeze({});function I$1(e,t,n){return void 0===n&&(n=C$1),e.theme!==n.theme&&e.theme||t||n.theme}var A=new Set(["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","track","u","ul","use","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","tspan"]),O=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,D=/(^-|-$)/g;function R(e){return e.replace(O,"-").replace(D,"")}var T=/(a)(d)/gi,k$1=52,j$1=function(e){return String.fromCharCode(e+(e>25?39:97))};function x$1(e){var t,n="";for(t=Math.abs(e);t>k$1;t=t/k$1|0)n=j$1(t%k$1)+n;return (j$1(t%k$1)+n).replace(T,"$1-$2")}var V,F=5381,M=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},z$1=function(e){return M(F,e)};function $$1(e){return x$1(z$1(e)>>>0)}function B(e){return "production"!==process.env.NODE_ENV&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function L(e){return "string"==typeof e&&("production"===process.env.NODE_ENV||e.charAt(0)===e.charAt(0).toLowerCase())}var G="function"==typeof Symbol&&Symbol.for,Y=G?Symbol.for("react.memo"):60115,q$1=G?Symbol.for("react.forward_ref"):60112,W$1={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},H={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},U$1={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},J=((V={})[q$1]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},V[Y]=U$1,V);function X(e){return ("type"in(t=e)&&t.type.$$typeof)===Y?U$1:"$$typeof"in e?J[e.$$typeof]:W$1;var t;}var Z=Object.defineProperty,K=Object.getOwnPropertyNames,Q=Object.getOwnPropertySymbols,ee=Object.getOwnPropertyDescriptor,te=Object.getPrototypeOf,ne=Object.prototype;function oe(e,t,n){if("string"!=typeof t){if(ne){var o=te(t);o&&o!==ne&&oe(e,o,n);}var r=K(t);Q&&(r=r.concat(Q(t)));for(var s=X(e),i=X(t),a=0;a<r.length;++a){var c=r[a];if(!(c in H||n&&n[c]||i&&c in i||s&&c in s)){var l=ee(t,c);try{Z(e,c,l);}catch(e){}}}}return e}function re(e){return "function"==typeof e}function se(e){return "object"==typeof e&&"styledComponentId"in e}function ie(e,t){return e&&t?"".concat(e," ").concat(t):e||t||""}function ae(e,t){if(0===e.length)return "";for(var n=e[0],o=1;o<e.length;o++)n+=t?t+e[o]:e[o];return n}function ce(e){return null!==e&&"object"==typeof e&&e.constructor.name===Object.name&&!("props"in e&&e.$$typeof)}function le(e,t,n){if(void 0===n&&(n=!1),!n&&!ce(e)&&!Array.isArray(e))return t;if(Array.isArray(t))for(var o=0;o<t.length;o++)e[o]=le(e[o],t[o]);else if(ce(t))for(var o in t)e[o]=le(e[o],t[o]);return e}function ue(e,t){Object.defineProperty(e,"toString",{value:t});}var pe="production"!==process.env.NODE_ENV?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n",18:"ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`"}:{};function de(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];for(var n=e[0],o=[],r=1,s=e.length;r<s;r+=1)o.push(e[r]);return o.forEach(function(e){n=n.replace(/%[a-z]/,e);}),n}function he(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];return "production"===process.env.NODE_ENV?new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t," for more information.").concat(n.length>0?" Args: ".concat(n.join(", ")):"")):new Error(de.apply(void 0,__spreadArray([pe[t]],n,!1)).trim())}var fe=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e;}return e.prototype.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},e.prototype.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,o=n.length,r=o;e>=r;)if((r<<=1)<0)throw he(16,"".concat(e));this.groupSizes=new Uint32Array(r),this.groupSizes.set(n),this.length=r;for(var s=o;s<r;s++)this.groupSizes[s]=0;}for(var i=this.indexOfGroup(e+1),a=(s=0,t.length);s<a;s++)this.tag.insertRule(i,t[s])&&(this.groupSizes[e]++,i++);},e.prototype.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),o=n+t;this.groupSizes[e]=0;for(var r=n;r<o;r++)this.tag.deleteRule(n);}},e.prototype.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],o=this.indexOfGroup(e),r=o+n,s=o;s<r;s++)t+="".concat(this.tag.getRule(s)).concat(g$1);return t},e}(),me=new Map,ye=new Map,ve=1,ge=function(e){if(me.has(e))return me.get(e);for(;ye.has(ve);)ve++;var t=ve++;if("production"!==process.env.NODE_ENV&&((0|t)<0||t>1073741824))throw he(16,"".concat(t));return me.set(e,t),ye.set(t,e),t},Se=function(e,t){ve=t+1,me.set(e,t),ye.set(t,e);},we="style[".concat(f$1,"][").concat(y$1,'="').concat(v$1,'"]'),be=new RegExp("^".concat(f$1,'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')),Ee=function(e,t,n){for(var o,r=n.split(","),s=0,i=r.length;s<i;s++)(o=r[s])&&e.registerName(t,o);},Ne=function(e,t){for(var n,o=(null!==(n=t.textContent)&&void 0!==n?n:"").split(g$1),r=[],s=0,i=o.length;s<i;s++){var a=o[s].trim();if(a){var c=a.match(be);if(c){var l=0|parseInt(c[1],10),u=c[2];0!==l&&(Se(u,l),Ee(e,u,c[3]),e.getTag().insertRules(l,r)),r.length=0;}else r.push(a);}}};function Pe(){return "undefined"!=typeof __webpack_nonce__?__webpack_nonce__:null}var _e=function(e){var t=document.head,n=e||t,o=document.createElement("style"),r=function(e){var t=Array.from(e.querySelectorAll("style[".concat(f$1,"]")));return t[t.length-1]}(n),s=void 0!==r?r.nextSibling:null;o.setAttribute(f$1,m$1),o.setAttribute(y$1,v$1);var i=Pe();return i&&o.setAttribute("nonce",i),n.insertBefore(o,s),o},Ce=function(){function e(e){this.element=_e(e),this.element.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,o=t.length;n<o;n++){var r=t[n];if(r.ownerNode===e)return r}throw he(17)}(this.element),this.length=0;}return e.prototype.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return !1}},e.prototype.deleteRule=function(e){this.sheet.deleteRule(e),this.length--;},e.prototype.getRule=function(e){var t=this.sheet.cssRules[e];return t&&t.cssText?t.cssText:""},e}(),Ie=function(){function e(e){this.element=_e(e),this.nodes=this.element.childNodes,this.length=0;}return e.prototype.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t);return this.element.insertBefore(n,this.nodes[e]||null),this.length++,!0}return !1},e.prototype.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--;},e.prototype.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),Ae=function(){function e(e){this.rules=[],this.length=0;}return e.prototype.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},e.prototype.deleteRule=function(e){this.rules.splice(e,1),this.length--;},e.prototype.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),Oe=S$1,De={isServer:!S$1,useCSSOMInjection:!w$1},Re=function(){function e(e,n,o){void 0===e&&(e=C$1),void 0===n&&(n={});var r=this;this.options=__assign(__assign({},De),e),this.gs=n,this.names=new Map(o),this.server=!!e.isServer,!this.server&&S$1&&Oe&&(Oe=!1,function(e){for(var t=document.querySelectorAll(we),n=0,o=t.length;n<o;n++){var r=t[n];r&&r.getAttribute(f$1)!==m$1&&(Ne(e,r),r.parentNode&&r.parentNode.removeChild(r));}}(this)),ue(this,function(){return function(e){for(var t=e.getTag(),n=t.length,o="",r=function(n){var r=function(e){return ye.get(e)}(n);if(void 0===r)return "continue";var s=e.names.get(r),i=t.getGroup(n);if(void 0===s||0===i.length)return "continue";var a="".concat(f$1,".g").concat(n,'[id="').concat(r,'"]'),c="";void 0!==s&&s.forEach(function(e){e.length>0&&(c+="".concat(e,","));}),o+="".concat(i).concat(a,'{content:"').concat(c,'"}').concat(g$1);},s=0;s<n;s++)r(s);return o}(r)});}return e.registerId=function(e){return ge(e)},e.prototype.reconstructWithOptions=function(n,o){return void 0===o&&(o=!0),new e(__assign(__assign({},this.options),n),this.gs,o&&this.names||void 0)},e.prototype.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},e.prototype.getTag=function(){return this.tag||(this.tag=(e=function(e){var t=e.useCSSOMInjection,n=e.target;return e.isServer?new Ae(n):t?new Ce(n):new Ie(n)}(this.options),new fe(e)));var e;},e.prototype.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},e.prototype.registerName=function(e,t){if(ge(e),this.names.has(e))this.names.get(e).add(t);else {var n=new Set;n.add(t),this.names.set(e,n);}},e.prototype.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(ge(e),n);},e.prototype.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear();},e.prototype.clearRules=function(e){this.getTag().clearGroup(ge(e)),this.clearNames(e);},e.prototype.clearTag=function(){this.tag=void 0;},e}(),Te=/&/g,ke=/^\s*\/\/.*$/gm;function je(e,t){return e.map(function(e){return "rule"===e.type&&(e.value="".concat(t," ").concat(e.value),e.value=e.value.replaceAll(",",",".concat(t," ")),e.props=e.props.map(function(e){return "".concat(t," ").concat(e)})),Array.isArray(e.children)&&"@keyframes"!==e.type&&(e.children=je(e.children,t)),e})}function xe(e){var t,n,o,r=void 0===e?C$1:e,s=r.options,i=void 0===s?C$1:s,a=r.plugins,c=void 0===a?_:a,l=function(e,o,r){return r.startsWith(n)&&r.endsWith(n)&&r.replaceAll(n,"").length>0?".".concat(t):e},u=c.slice();u.push(function(e){e.type===RULESET&&e.value.includes("&")&&(e.props[0]=e.props[0].replace(Te,n).replace(o,l));}),i.prefix&&u.push(prefixer),u.push(stringify);var p=function(e,r,s,a){void 0===r&&(r=""),void 0===s&&(s=""),void 0===a&&(a="&"),t=a,n=r,o=new RegExp("\\".concat(n,"\\b"),"g");var c=e.replace(ke,""),l=compile(s||r?"".concat(s," ").concat(r," { ").concat(c," }"):c);i.namespace&&(l=je(l,i.namespace));var p=[];return serialize(l,middleware(u.concat(rulesheet(function(e){return p.push(e)})))),p};return p.hash=c.length?c.reduce(function(e,t){return t.name||he(15),M(e,t.name)},F).toString():"",p}var Ve=new Re,Fe=xe(),Me=e$1.createContext({shouldForwardProp:void 0,styleSheet:Ve,stylis:Fe});Me.Consumer;e$1.createContext(void 0);function Be(){return useContext(Me)}var Ge=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=Fe);var o=n.name+t.hash;e.hasNameForId(n.id,o)||e.insertRules(n.id,o,t(n.rules,o,"@keyframes"));},this.name=e,this.id="sc-keyframes-".concat(e),this.rules=t,ue(this,function(){throw he(12,String(n.name))});}return e.prototype.getName=function(e){return void 0===e&&(e=Fe),this.name+e.hash},e}(),Ye=function(e){return e>="A"&&e<="Z"};function qe(e){for(var t="",n=0;n<e.length;n++){var o=e[n];if(1===n&&"-"===o&&"-"===e[0])return e;Ye(o)?t+="-"+o.toLowerCase():t+=o;}return t.startsWith("ms-")?"-"+t:t}var We=function(e){return null==e||!1===e||""===e},He=function(t){var n,o,r=[];for(var s in t){var i=t[s];t.hasOwnProperty(s)&&!We(i)&&(Array.isArray(i)&&i.isCss||re(i)?r.push("".concat(qe(s),":"),i,";"):ce(i)?r.push.apply(r,__spreadArray(__spreadArray(["".concat(s," {")],He(i),!1),["}"],!1)):r.push("".concat(qe(s),": ").concat((n=s,null==(o=i)||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||n in unitlessKeys||n.startsWith("--")?String(o).trim():"".concat(o,"px")),";")));}return r};function Ue(e,t,n,o){if(We(e))return [];if(se(e))return [".".concat(e.styledComponentId)];if(re(e)){if(!re(s=e)||s.prototype&&s.prototype.isReactComponent||!t)return [e];var r=e(t);return "production"===process.env.NODE_ENV||"object"!=typeof r||Array.isArray(r)||r instanceof Ge||ce(r)||null===r||console.error("".concat(B(e)," is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")),Ue(r,t,n,o)}var s;return e instanceof Ge?n?(e.inject(n,o),[e.getName(o)]):[e]:ce(e)?He(e):Array.isArray(e)?Array.prototype.concat.apply(_,e.map(function(e){return Ue(e,t,n,o)})):[e.toString()]}function Je(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(re(n)&&!se(n))return !1}return !0}var Xe=z$1(v$1),Ze=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"===process.env.NODE_ENV&&(void 0===n||n.isStatic)&&Je(e),this.componentId=t,this.baseHash=M(Xe,t),this.baseStyle=n,Re.registerId(t);}return e.prototype.generateAndInjectStyles=function(e,t,n){var o=this.baseStyle?this.baseStyle.generateAndInjectStyles(e,t,n):"";if(this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(this.componentId,this.staticRulesId))o=ie(o,this.staticRulesId);else {var r=ae(Ue(this.rules,e,t,n)),s=x$1(M(this.baseHash,r)>>>0);if(!t.hasNameForId(this.componentId,s)){var i=n(r,".".concat(s),void 0,this.componentId);t.insertRules(this.componentId,s,i);}o=ie(o,s),this.staticRulesId=s;}else {for(var a=M(this.baseHash,n.hash),c="",l=0;l<this.rules.length;l++){var u=this.rules[l];if("string"==typeof u)c+=u,"production"!==process.env.NODE_ENV&&(a=M(a,u));else if(u){var p=ae(Ue(u,e,t,n));a=M(a,p+l),c+=p;}}if(c){var d=x$1(a>>>0);t.hasNameForId(this.componentId,d)||t.insertRules(this.componentId,d,n(c,".".concat(d),void 0,this.componentId)),o=ie(o,d);}}return o},e}(),Ke=e$1.createContext(void 0);Ke.Consumer;function tt(e){var n=e$1.useContext(Ke),r=useMemo(function(){return function(e,n){if(!e)throw he(14);if(re(e)){var o=e(n);if("production"!==process.env.NODE_ENV&&(null===o||Array.isArray(o)||"object"!=typeof o))throw he(7);return o}if(Array.isArray(e)||"object"!=typeof e)throw he(8);return n?__assign(__assign({},n),e):e}(e.theme,n)},[e.theme,n]);return e.children?e$1.createElement(Ke.Provider,{value:r},e.children):null}var nt={},ot=new Set;function rt(e,r,s){var i=se(e),a=e,c=!L(e),p=r.attrs,d=void 0===p?_:p,h=r.componentId,f=void 0===h?function(e,t){var n="string"!=typeof e?"sc":R(e);nt[n]=(nt[n]||0)+1;var o="".concat(n,"-").concat($$1(v$1+n+nt[n]));return t?"".concat(t,"-").concat(o):o}(r.displayName,r.parentComponentId):h,m=r.displayName,y=void 0===m?function(e){return L(e)?"styled.".concat(e):"Styled(".concat(B(e),")")}(e):m,g=r.displayName&&r.componentId?"".concat(R(r.displayName),"-").concat(r.componentId):r.componentId||f,S=i&&a.attrs?a.attrs.concat(d).filter(Boolean):d,w=r.shouldForwardProp;if(i&&a.shouldForwardProp){var b=a.shouldForwardProp;if(r.shouldForwardProp){var E=r.shouldForwardProp;w=function(e,t){return b(e,t)&&E(e,t)};}else w=b;}var N=new Ze(s,g,i?a.componentStyle:void 0);function O(e,r){return function(e,r,s){var i=e.attrs,a=e.componentStyle,c=e.defaultProps,p=e.foldedComponentIds,d=e.styledComponentId,h=e.target,f=e$1.useContext(Ke),m=Be(),y=e.shouldForwardProp||m.shouldForwardProp;"production"!==process.env.NODE_ENV&&useDebugValue(d);var v=I$1(r,f,c)||C$1,g=function(e,n,o){for(var r,s=__assign(__assign({},n),{className:void 0,theme:o}),i=0;i<e.length;i+=1){var a=re(r=e[i])?r(s):r;for(var c in a)s[c]="className"===c?ie(s[c],a[c]):"style"===c?__assign(__assign({},s[c]),a[c]):a[c];}return n.className&&(s.className=ie(s.className,n.className)),s}(i,r,v),S=g.as||h,w={};for(var b in g)void 0===g[b]||"$"===b[0]||"as"===b||"theme"===b&&g.theme===v||("forwardedAs"===b?w.as=g.forwardedAs:y&&!y(b,S)||(w[b]=g[b],y||"development"!==process.env.NODE_ENV||isPropValid(b)||ot.has(b)||!A.has(S)||(ot.add(b),console.warn('styled-components: it looks like an unknown prop "'.concat(b,'" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));var E=function(e,t){var n=Be(),o=e.generateAndInjectStyles(t,n.styleSheet,n.stylis);return "production"!==process.env.NODE_ENV&&useDebugValue(o),o}(a,g);"production"!==process.env.NODE_ENV&&e.warnTooManyClasses&&e.warnTooManyClasses(E);var N=ie(p,d);return E&&(N+=" "+E),g.className&&(N+=" "+g.className),w[L(S)&&!A.has(S)?"class":"className"]=N,w.ref=s,createElement(S,w)}(D,e,r)}O.displayName=y;var D=e$1.forwardRef(O);return D.attrs=S,D.componentStyle=N,D.displayName=y,D.shouldForwardProp=w,D.foldedComponentIds=i?ie(a.foldedComponentIds,a.styledComponentId):"",D.styledComponentId=g,D.target=i?a.target:e,Object.defineProperty(D,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(e){this._foldedDefaultProps=i?function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];for(var o=0,r=t;o<r.length;o++)le(e,r[o],!0);return e}({},a.defaultProps,e):e;}}),"production"!==process.env.NODE_ENV&&(P(y,g),D.warnTooManyClasses=function(e,t){var n={},o=!1;return function(r){if(!o&&(n[r]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'.concat(t,'"'):"";console.warn("Over ".concat(200," classes were generated for component ").concat(e).concat(s,".\n")+"Consider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),o=!0,n={};}}}(y,g)),ue(D,function(){return ".".concat(D.styledComponentId)}),c&&oe(D,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0}),D}function st(e,t){for(var n=[e[0]],o=0,r=t.length;o<r;o+=1)n.push(t[o],e[o+1]);return n}var it=function(e){return Object.assign(e,{isCss:!0})};function at(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];if(re(t)||ce(t))return it(Ue(st(_,__spreadArray([t],n,!0))));var r=t;return 0===n.length&&1===r.length&&"string"==typeof r[0]?Ue(r):it(Ue(st(r,n)))}function ct(n,o,r){if(void 0===r&&(r=C$1),!o)throw he(1,o);var s=function(t){for(var s=[],i=1;i<arguments.length;i++)s[i-1]=arguments[i];return n(o,r,at.apply(void 0,__spreadArray([t],s,!1)))};return s.attrs=function(e){return ct(n,o,__assign(__assign({},r),{attrs:Array.prototype.concat(r.attrs,e).filter(Boolean)}))},s.withConfig=function(e){return ct(n,o,__assign(__assign({},r),e))},s}var lt=function(e){return ct(rt,e)},ut=lt;A.forEach(function(e){ut[e]=lt(e);});"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native");var gt="__sc-".concat(f$1,"__");"production"!==process.env.NODE_ENV&&"test"!==process.env.NODE_ENV&&"undefined"!=typeof window&&(window[gt]||(window[gt]=0),1===window[gt]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window[gt]+=1);

function i(e,n){return Object.defineProperty?Object.defineProperty(e,"raw",{value:n}):e.raw=n,e}"function"==typeof SuppressedError&&SuppressedError;var l,s,a,p,d,c,m,f,u,g=ut.div.withConfig({componentId:"om-spb-12hi9ji"})(l||(l=i(["\n  width: 100%;\n  margin: 0 auto;\n  overflow: visible;\n"],["\n  width: 100%;\n  margin: 0 auto;\n  overflow: visible;\n"]))),h=function(n){var r=n.children;return e$1.createElement(g,{"data-testid":"om-progress-steps-main-container"},r)},b=ut.div.withConfig({componentId:"om-spb-11z01ws"})(s||(s=i(["\n  margin-top: 0;\n  display: grid;\n  grid-template-columns: ",";\n"],["\n  margin-top: 0;\n  display: grid;\n  grid-template-columns: ",";\n"])),(function(e){return "repeat(".concat(e.$stepCount,", minmax(0, 1fr) 16px)")})),v=function(n){var r=n.stepCount,t=n.children;return e$1.createElement(b,{"data-testid":"om-progress-steps-step-container",$stepCount:r},t)},w=ut(FlexBox).withConfig({componentId:"om-spb-1vgzw9w"})(a||(a=i(["\n  color: ",";\n  text-align: center;\n"],["\n  color: ",";\n  text-align: center;\n"])),(function(e){return e.theme.colors.text})),x=function(n){var r=n.children;return e$1.createElement(w,{flexWrap:"wrap",justifyContent:"center",alignItems:"center",fontSize:"xsmall"},r)},y=ut.div.withConfig({componentId:"om-spb-1unw4y1"})(p||(p=i(["\n  position: relative;\n  justify-self: center;\n"],["\n  position: relative;\n  justify-self: center;\n"]))),k=ut(y).withConfig({componentId:"om-spb-e0v00t"})(d||(d=i(["\n  grid-row: 1;\n  align-self: end;\n"],["\n  grid-row: 1;\n  align-self: end;\n"]))),C=ut(y).withConfig({componentId:"om-spb-1rb4280"})(c||(c=i(["\n  grid-row: 3;\n  align-self: start;\n"],["\n  grid-row: 3;\n  align-self: start;\n"]))),E=function(n){var r=n.aboveLine,t=void 0===r||r,o=n.children;return t?e$1.createElement(k,{"data-testid":"om-progress-step-label"},o):e$1.createElement(C,{"data-testid":"om-progress-step-description"},o)},S=ut.div.withConfig({componentId:"om-spb-1ayhru4"})(m||(m=i(["\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: ",";\n  transition: 0.4s ease;\n  place-self: center center;\n  grid-row: 2;\n"],["\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: ",";\n  transition: 0.4s ease;\n  place-self: center center;\n  grid-row: 2;\n"])),(function(e){return e.$unqualified?e.theme.colors.empty:e.theme.colors.filled})),z=function(n){var r=n.unqualified,t=void 0===r||r;return e$1.createElement(S,{$unqualified:t,"data-testid":"om-progress-step-indicator"})},I=ut.div.withConfig({componentId:"om-spb-16npgsv"})(f||(f=i(["\n  position: relative;\n  z-index: 1;\n  align-self: center;\n  display: grid;\n  grid-template-rows: minmax(0, 1fr) 16px minmax(0, 1fr);\n  grid-template-columns: subgrid;\n"],["\n  position: relative;\n  z-index: 1;\n  align-self: center;\n  display: grid;\n  grid-template-rows: minmax(0, 1fr) 16px minmax(0, 1fr);\n  grid-template-columns: subgrid;\n"]))),W=function(n){var r=n.children;return e$1.createElement(I,{"data-testid":"om-progress-step-wrapper"},r)},j=ut.progress.withConfig({componentId:"om-spb-4zclxp"})(u||(u=i(["\n  /* stylelint-disable property-no-vendor-prefix -- vendor prefixes needed for the html5 progress element styling */\n\n  /* Reset the default appearance */\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: none;\n  height: 5px;\n  max-width: 100%;\n  width: 100%;\n  align-self: center;\n\n  /* controls the empty part of the progress element in firefox */\n  background-color: ",';\n\n  /* \n   * controls the "empty" part of the progress element in webkit\n   * see: https://developer.mozilla.org/en-US/docs/Web/CSS/::-webkit-progress-bar\n  */\n  &::-webkit-progress-bar {\n    background: ',';\n  }\n\n  /*\n   * controls the "filled in" part of the progress element in webkit\n   * see: https://developer.mozilla.org/en-US/docs/Web/CSS/::-webkit-progress-value\n   */\n  &::-webkit-progress-value {\n    background-color: ',';\n  }\n\n  /*\n   * controls the "filled in" part of the progress element in firefox\n   * see: https://developer.mozilla.org/en-US/docs/Web/CSS/::-moz-progress-bar\n   */\n  &::-moz-progress-bar {\n    background: ',";\n  }\n\n  /* stylelint-enable property-no-vendor-prefix */\n"],["\n  /* stylelint-disable property-no-vendor-prefix -- vendor prefixes needed for the html5 progress element styling */\n\n  /* Reset the default appearance */\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: none;\n  height: 5px;\n  max-width: 100%;\n  width: 100%;\n  align-self: center;\n\n  /* controls the empty part of the progress element in firefox */\n  background-color: ",';\n\n  /* \n   * controls the "empty" part of the progress element in webkit\n   * see: https://developer.mozilla.org/en-US/docs/Web/CSS/::-webkit-progress-bar\n  */\n  &::-webkit-progress-bar {\n    background: ',';\n  }\n\n  /*\n   * controls the "filled in" part of the progress element in webkit\n   * see: https://developer.mozilla.org/en-US/docs/Web/CSS/::-webkit-progress-value\n   */\n  &::-webkit-progress-value {\n    background-color: ',';\n  }\n\n  /*\n   * controls the "filled in" part of the progress element in firefox\n   * see: https://developer.mozilla.org/en-US/docs/Web/CSS/::-moz-progress-bar\n   */\n  &::-moz-progress-bar {\n    background: ',";\n  }\n\n  /* stylelint-enable property-no-vendor-prefix */\n"])),(function(e){return e.theme.colors.empty}),(function(e){return e.theme.colors.empty}),(function(e){return e.theme.colors.filled}),(function(e){return e.theme.colors.filled})),U=function(n){var r=n.max,t=void 0===r?100:r,o=n.value;return e$1.createElement(j,{"data-testid":"om-progress-bar",max:t,value:o})},q={colors:{filled:"var(--swan-base-color-green-700)",empty:"var(--swan-sem-color-bg-hover)",text:"var(--swan-sem-color-text-standard)"}},$=function(n){var r=n.steps,o=n.totalValue,i=n.theme,l=void 0===i?q:i,s=r.filter((function(e){return !e.isComplete}));if(!r||0===r.length)return null;var a=function(e,n,t){var o;if("number"!=typeof e)return t.isComplete?100:0===s.findIndex((function(e){return e===t}))?50:0;if("number"==typeof e&&n){if(e>n)return 100;var i=(null===(o=r[r.findIndex((function(e){return e===t}))-1])||void 0===o?void 0:o.threshold)||0;return Math.floor((e-i)/(n-i)*100)}};return e$1.createElement(tt,{theme:l},e$1.createElement(h,null,e$1.createElement(v,{stepCount:r.length},r.map((function(n,r){var t=n.label,i=n.description,l=n.isComplete,s=n.threshold;return e$1.createElement(e$1.Fragment,{key:r},e$1.createElement(U,{value:"".concat(a(o,s,n))}),e$1.createElement(W,null,t&&e$1.createElement(E,null,e$1.createElement(x,null,t)),e$1.createElement(z,{unqualified:!l}),i&&e$1.createElement(E,{aboveLine:!1},e$1.createElement(x,null,i))))})))))};

var localeTaxNameMap = {
  'en-NZ': 'GST'
};
/**
 * Given a locale return the tax name for display. If we do not have a mapping
 * for the given locale, return undefined.
 * @param locale
 */
var getTaxNameForLocale = function (locale) {
  return localeTaxNameMap[locale];
};

var FreeShippingProgressBarDisplay = function (_a) {
  var freeShippingDetails = _a.freeShippingDetails,
    locale = _a.locale,
    localizedShippingOptionName = _a.localizedShippingOptionName,
    currency = _a.currency,
    fractionDigits = _a.fractionDigits,
    _b = _a.variant,
    variant = _b === void 0 ? 'standard' : _b;
  var messages = m$2(['messages'])[0];
  var orderThresholdCents = freeShippingDetails.orderThresholdCents,
    amountToFreeCents = freeShippingDetails.amountToFreeCents,
    includesTax = freeShippingDetails.includesTax;
  var currencyLocale = locale.replace('_', '-');
  // early out and return free shipping with $0 threshold message
  if (amountToFreeCents === 0 && orderThresholdCents === 0) {
    return /*#__PURE__*/e$1.createElement(Typography, {
      fontSize: "small"
    }, /*#__PURE__*/e$1.createElement(b$1, {
      tokenizedString: messages.freeShippingNoThresholdMessage,
      substitutions: {
        shippingOptionName: localizedShippingOptionName
      }
    }));
  }
  var localizedTaxName = getTaxNameForLocale(locale);
  var taxAwareMessages = {
    thresholdReached: '',
    progress: ''
  };
  // construct tax aware messages
  if (includesTax && localizedTaxName) {
    // tax inclusive with custom tax name
    taxAwareMessages.thresholdReached = messages.freeShippingThresholdReachedMessageWithTaxTypes;
    taxAwareMessages.progress = messages.freeShippingProgressMessageWithTaxTypes;
  } else if (includesTax && !localizedTaxName) {
    // tax inclusive with default tax name
    taxAwareMessages.thresholdReached = messages.freeShippingThresholdReachedMessage;
    taxAwareMessages.progress = messages.freeShippingProgressMessage;
  } else if (!includesTax && localizedTaxName) {
    // tax exclusive with custom tax name
    taxAwareMessages.thresholdReached = messages.freeShippingThresholdReachedMessageExTax;
    taxAwareMessages.progress = messages.freeShippingProgressMessageExTax;
  } else {
    // tax exclusive with default tax name
    taxAwareMessages.thresholdReached = messages.freeShippingThresholdReachedMessageExTaxGeneric;
    taxAwareMessages.progress = messages.freeShippingProgressMessageExTaxGeneric;
  }
  var isComplete = amountToFreeCents <= 0;
  return /*#__PURE__*/e$1.createElement(e$1.Fragment, null, /*#__PURE__*/e$1.createElement($, {
    totalValue: freeShippingDetails.orderThresholdCents - freeShippingDetails.amountToFreeCents,
    steps: [{
      threshold: freeShippingDetails.orderThresholdCents,
      label: variant === 'compact' ? undefined : messages.freeShippingProgressBarLabel,
      description: variant === 'compact' ? undefined : ( /*#__PURE__*/e$1.createElement(b$1, {
        tokenizedString: messages.freeShippingProgressBarDescription,
        substitutions: {
          amountToFree: ( /*#__PURE__*/e$1.createElement(Currency, {
            locale: locale.replace('_', '-'),
            cents: freeShippingDetails.orderThresholdCents,
            currency: currency,
            fractionDigits: fractionDigits
          }))
        }
      })),
      isComplete: isComplete
    }]
  }), /*#__PURE__*/e$1.createElement(Typography, {
    fontSize: "small"
  }, isComplete ? ( /*#__PURE__*/e$1.createElement(b$1, {
    tokenizedString: taxAwareMessages.thresholdReached,
    substitutions: {
      shippingOptionName: localizedShippingOptionName,
      taxTypes: localizedTaxName,
      orderThreshold: ( /*#__PURE__*/e$1.createElement(Currency, {
        locale: currencyLocale,
        cents: orderThresholdCents,
        currency: currency,
        fractionDigits: fractionDigits
      }))
    }
  })) : ( /*#__PURE__*/e$1.createElement(b$1, {
    tokenizedString: taxAwareMessages.progress,
    substitutions: {
      shippingOptionName: localizedShippingOptionName,
      taxTypes: localizedTaxName,
      amountToFree: ( /*#__PURE__*/e$1.createElement(Currency, {
        locale: currencyLocale,
        cents: amountToFreeCents,
        currency: currency,
        fractionDigits: fractionDigits
      })),
      orderThreshold: ( /*#__PURE__*/e$1.createElement(Currency, {
        locale: locale.replace('_', '-'),
        cents: freeShippingDetails.orderThresholdCents,
        currency: currency,
        fractionDigits: fractionDigits
      }))
    }
  }))));
};

var TenantOptions = function (_a) {
  var auth = _a.auth,
    tenant = _a.tenant,
    locale = _a.locale,
    lastModifiedDate = _a.lastModifiedDate,
    destinationCountry = _a.destinationCountry,
    vistacartUrl = _a.vistacartUrl,
    requestor = _a.requestor,
    variant = _a.variant;
  var _b = useState([]),
    pricedShippingOptions = _b[0],
    setPricedShippingOptions = _b[1];
  var _c = useState({}),
    shippingIdToDisplayNames = _c[0],
    setShippingIdToDisplayNames = _c[1];
  var getIdToDisplayNames = function (speedoShippingOptions) {
    if (speedoShippingOptions === void 0) {
      speedoShippingOptions = [];
    }
    var idToDisplayNames = {};
    speedoShippingOptions.forEach(function (option) {
      idToDisplayNames[option.id] = option.displayNames;
    });
    return idToDisplayNames;
  };
  var _d = auth.authHeader,
    authHeader = _d === void 0 ? '' : _d,
    _e = auth.shopperId,
    shopperId = _e === void 0 ? '' : _e;
  useEffect(function () {
    var shippingOptionsToPrice;
    getDeliveryOptions(authHeader, tenant, destinationCountry).then(function (deliveryOptions) {
      shippingOptionsToPrice = getShippingOptionsToPriceFromSpeedo(deliveryOptions);
      priceShippingMethods(shopperId, authHeader, tenant, shippingOptionsToPrice, vistacartUrl || 'https://vistacart.orders.vpsvc.com', requestor).then(function (data) {
        setPricedShippingOptions((data === null || data === void 0 ? void 0 : data.pricedShippingMethods) || []);
        setShippingIdToDisplayNames(getIdToDisplayNames(deliveryOptions));
      });
    });
  }, [destinationCountry, lastModifiedDate, tenant, authHeader, shopperId, vistacartUrl, requestor]);
  var _f = getNearestFreeShipping(pricedShippingOptions) || {},
    freeShippingDetails = _f.freeShippingDetails,
    shippingMethodId = _f.shippingMethodId,
    fractionDigits = _f.fractionDigits,
    currency = _f.currency;
  // if there are no delivery options or none of the delivery options have free shipping render nothing
  if (pricedShippingOptions.length === 0 || !freeShippingDetails) {
    return null;
  }
  var localizedShippingOptionName = getLocalizedSpeedoShippingName(shippingMethodId || '', shippingIdToDisplayNames, locale);
  return /*#__PURE__*/e$1.createElement(h$1, {
    translationResources: translationResources,
    locale: locale,
    logLevel: "ERROR"
  }, /*#__PURE__*/e$1.createElement(FreeShippingProgressBarDisplay, {
    freeShippingDetails: freeShippingDetails,
    locale: locale,
    localizedShippingOptionName: localizedShippingOptionName,
    currency: currency || '',
    fractionDigits: fractionDigits || 0,
    variant: variant
  }));
};

var ClientProvidedOptions = function (_a) {
  var _b, _c;
  var locale = _a.locale,
    shippingQuotes = _a.shippingQuotes,
    variant = _a.variant;
  // first, map shipping quotes to "DeliveryOption" model
  var shippingQuoteToDisplay = getNearestFreeShippingForClientOptions(shippingQuotes);
  if ((_b = shippingQuoteToDisplay === null || shippingQuoteToDisplay === void 0 ? void 0 : shippingQuoteToDisplay.pricingData) === null || _b === void 0 ? void 0 : _b.freeShippingDetails) {
    var _d = shippingQuoteToDisplay.pricingData,
      freeShippingDetails = _d.freeShippingDetails,
      currency = _d.currency,
      fractionDigits = _d.fractionDigits,
      displayData = shippingQuoteToDisplay.displayText.displayData;
    var localizedShippingOptionName = (_c = displayData.find(function (dt) {
      var _a;
      return ((_a = dt.locale) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (locale === null || locale === void 0 ? void 0 : locale.toLowerCase());
    })) === null || _c === void 0 ? void 0 : _c.name;
    // extra safety check to ensure we have a display name available
    if (!localizedShippingOptionName) {
      return null;
    }
    return /*#__PURE__*/e$1.createElement(h$1, {
      translationResources: translationResources,
      locale: locale
    }, /*#__PURE__*/e$1.createElement(FreeShippingProgressBarDisplay, {
      freeShippingDetails: freeShippingDetails,
      locale: locale,
      localizedShippingOptionName: localizedShippingOptionName,
      currency: currency,
      fractionDigits: fractionDigits,
      variant: variant
    }));
  }
  // if there is no "shipping quote to display" rendering nothing.
  return null;
};

var FreeShippingProgressBar = function (props) {
  var locale = props.locale,
    variant = props.variant;
  // if the client provided shipping quotes use those for display
  if ('shippingQuotes' in props) {
    var shippingQuotes = props.shippingQuotes;
    return /*#__PURE__*/e$1.createElement(ClientProvidedOptions, {
      locale: locale,
      shippingQuotes: shippingQuotes,
      variant: variant
    });
  }
  // otherwise, use the "tenant options"
  var auth = props.auth,
    tenant = props.tenant,
    lastModifiedDate = props.lastModifiedDate,
    destinationCountry = props.destinationCountry,
    vistacartUrl = props.vistacartUrl,
    requestor = props.requestor;
  return /*#__PURE__*/e$1.createElement(TenantOptions, {
    auth: auth,
    tenant: tenant,
    locale: locale,
    lastModifiedDate: lastModifiedDate,
    destinationCountry: destinationCountry,
    vistacartUrl: vistacartUrl,
    requestor: requestor,
    variant: variant
  });
};

export { FreeShippingProgressBar };
//# sourceMappingURL=index.esm.js.map
